/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axiosInstance from "../../libs/axios"

export default {

    getIndexPatients({dispatch, commit}, payload) {

        let queryParam = payload.skip ? "&skip=" + payload.skip : "";
        if(payload.searchWord && payload.searchWord.length !== 0) {queryParam += "&searchWord=" + payload.searchWord;}
        queryParam += payload.institutionId ? "&institutionId=" + payload.institutionId : ""

        return new Promise((resolve, reject) => {
            axiosInstance.get("/patients/patient_types/index/patients?" + queryParam).then((response) => {
                commit("SET_INDEX_PATIENTS", response.data.data);
                commit("SET_INDEX_META", response.data.meta);
                resolve(response.data.data)
            })
                .catch((error) => {
                    reject(error)
                })
        })
    },

    getIndexPatientInfo({dispatch, commit}, payload) {

        return new Promise((resolve, reject) => {
            axiosInstance.get("/patients/patient_types/index/" + payload.id).then((response) => {
                commit("SET_INDEX_PATIENT_INFO", response.data);
                resolve(response.data)
            })
                .catch((error) => {
                    reject(error)
                })
        })
    },

    updateIndexPatientInfo({dispatch, commit}, payload) {

        return new Promise((resolve, reject) => {
            axiosInstance.put("patients/patient_types/index/patients/" + payload.id, payload).then((res) => {
                const response = res.data.data
                commit("SET_INDEX_PATIENT_INFO", response.data);
                resolve(response.data)
            })
                .catch((error) => {
                    reject(error)
                })
        })
    },

    getContactInfo({dispatch, commit}, payload) {

        return new Promise((resolve, reject) => {
            axiosInstance.get("/patients/patient_types/contact/" + payload.id).then((response) => {
                commit("SET_PATIENT_INFO", response.data);
                resolve(response.data)
            })
                .catch((error) => {
                    reject(error)
                })
        })
    },


    updateContactInfo({dispatch, commit}, payload) {

        return new Promise((resolve, reject) => {
            axiosInstance.put("patients/patient_types/contact/" + payload.id, payload).then((res) => {
                const response = res.data.data
                commit("SET_PATIENT_INFO", response.data);
                resolve(response.data)
            })
                .catch((error) => {
                    reject(error)
                })
        })
    },

    getRiskGroupInfo({dispatch, commit}, payload) {

        return new Promise((resolve, reject) => {
            axiosInstance.get("/patients/patient_types/risk_group/" + payload.id).then((response) => {
                commit("SET_PATIENT_INFO", response.data);
                resolve(response.data)
            })
                .catch((error) => {
                    reject(error)
                })
        })
    },

    updateRiskGroupInfo({dispatch, commit}, payload) {

        return new Promise((resolve, reject) => {
            axiosInstance.put("/patients/patient_types/risk_group/patients/" + payload.id, payload).then((res) => {
                const response = res.data.data
                commit("SET_PATIENT_INFO", response.data);
                resolve(response.data)
            })
                .catch((error) => {
                    reject(error)
                })
        })
    },

    getContactTreatments({dispatch, commit}, payload) {

        return new Promise((resolve, reject) => {
            axiosInstance.get("/patients/" + payload.id + "/treatments/current").then((response) => {
                commit("SET_PATIENT_TREATMENTS", response.data);
                resolve(response.data)
            })
                .catch((error) => {
                    reject(error)
                })
        })
    },

    getContactResearches({dispatch, commit}, payload) {

        return new Promise((resolve, reject) => {
            axiosInstance.get("/patients/" + payload.id + "/researches").then((response) => {
                commit("SET_PATIENT_RESEARCHES", response.data);
                resolve(response.data)
            })
                .catch((error) => {
                    reject(error)
                })
        })
    },

    getIndexPatientCurrentCases({dispatch, commit}, payload) {

        return new Promise((resolve, reject) => {
            axiosInstance.get("/patients/patient_types/index/" + payload.id + "/cases/current").then((response) => {
                commit("SET_INDEX_PATIENT_CURRENT_CASES", response.data);
                resolve(response.data)
            })
                .catch((error) => {
                    reject(error)
                })
        })
    },

    getIndexPatientContacts({dispatch, commit}, payload) {

        return new Promise((resolve, reject) => {
            axiosInstance.get("/patients/patient_types/index/" + payload.id + "/contacts").then((response) => {
                commit("SET_INDEX_PATIENT_CONTACTS", response.data);
                resolve(response.data)
            })
                .catch((error) => {
                    reject(error)
                })
        })
    },

    getContacts({dispatch, commit}, payload) {

        let queryParam = payload.skip ? "&skip=" + payload.skip : "";
        if(payload.searchWord && payload.searchWord.length !== 0) {queryParam += "&searchWord=" + payload.searchWord;}
        queryParam += payload.institutionId ? "&institutionId=" + payload.institutionId : ""

        return new Promise((resolve, reject) => {
            axiosInstance.get("/patients/patient_types/contact/patients?" + queryParam, payload).then((response) => {
                commit("SET_CONTACTS", response.data.data);
                commit("SET_CONTACTS_META", response.data.meta);
                resolve(response.data.data)
            })
                .catch((error) => {
                    reject(error)
                })
        })
    },

    getRiskGroups({dispatch, commit}, payload) {
        let queryParam = "&skip=" + payload.skip;
        if(payload.searchWord && payload.searchWord.length !== 0) {queryParam += "&searchWord=" + payload.searchWord;}

        return new Promise((resolve, reject) => {
            axiosInstance.get("/patients/patient_types/risk_group/patients?" + queryParam, payload).then((response) => {
                commit("SET_RISK_GROUPS", response.data.data);
                commit("SET_RISK_GROUPS_META", response.data.meta);
                resolve(response.data.data)
            })
                .catch((error) => {
                    reject(error)
                })
        })
    },

    getPatientFollowups({dispatch, commit}, payload) {

        return new Promise((resolve, reject) => {
            axiosInstance.get("/patients/" + payload.id + "/history_types/followup/histories", payload).then((response) => {
                commit("SET_FOLLOWUPS", response.data);
                resolve(response.data.data)
            })
                .catch((error) => {
                    reject(error)
                })
        })
    },

    getPatientCases({dispatch, commit}, payload) {

        return new Promise((resolve, reject) => {
            axiosInstance.get("/patients/patient_types/index/" + payload.id + "/cases", payload).then((response) => {
                commit("SET_CASES", response.data);
                resolve(response.data.data)
            })
                .catch((error) => {
                    reject(error)
                })
        })
    },

    deletePatient({dispatch, commit}, payload) {

        return new Promise((resolve, reject) => {
            axiosInstance.delete("/patients/" + payload).then((response) => {
                resolve(response.data.data.data)
            })
                .catch((error) => {
                    reject(error)
                })
        })
    },
}
